/**
 * Centralized path construction. Replaces route-ref-based linking: in the
 * new frontend system, `type` is passed into pages as a literal prop (see
 * plugin.tsx) rather than read from a URL param, so there's no dynamic
 * route ref to resolve against. Paths are still built in exactly one place,
 * so nothing outside this file hardcodes a route string.
 *
 * IMPORTANT: buildDetailsPath is used for two different purposes — building
 * a real navigation target (buildDetailsPath('flink', 'flink-prod')) AND
 * building the route *pattern* itself (buildDetailsPath('flink', ':name')
 * in plugin.tsx). Do not URL-encode `name` here: Backstage entity names are
 * restricted to [a-zA-Z0-9-_.], all URL-safe, so encoding buys nothing for
 * real names — but it silently mangles the ':name' placeholder into
 * '%3Aname' when building the pattern, which breaks the route entirely.
 */
export function buildTypeListPath(type: string): string {
  return `/applications/${type}`;
}

export function buildDetailsPath(type: string, name: string): string {
  return `/applications/${type}/${name}`;
}
